import ClientParkingAvailabilityList from "../../components/ClientParkingAvailabilityList";

const ClientParkingAvailabilityListPage = () => {
  return <ClientParkingAvailabilityList />;
};

export default ClientParkingAvailabilityListPage;
